import { backgroundColor, textSize, zIndex } from 'styles'

const previewBaneerStyles = {
  baneer: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    ...zIndex('previewBaneer'),
    padding: '8px 10px',
    ...textSize(14, 18),
    ...backgroundColor('textError'),
    color: '#FFF'
  },
  close: {
    display: 'inline-block',
    verticalAlign: 'middle',
    cursor: 'pointer',
    fontSize: 20,
    marginLeft: 8
  }
}

export default previewBaneerStyles
